<div class="sidebar" [class.open]="sidebarOpen">
  <div class="metadata-content scrollbar">
    <app-sidebar-metadata-content [metadataList]="metadataList"></app-sidebar-metadata-content>
  </div>
  <div class="ask-the-author">
    <hr />
    <app-ask-the-author [authors]="authors" [isAskAuthorEnabled]="analysis?.entitled" (clickAskAuthor)="onAskTheAuthor()"></app-ask-the-author>
  </div>
</div>
